module.exports = __webpack_public_path__ + "static/media/eerdun.9a3433a4.png";